import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [

  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'fogotpassword',
    loadChildren: () => import('./fogotpassword/fogotpassword.module').then( m => m.FogotpasswordPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'plants',
    loadChildren: () => import('./plants/plants.module').then( m => m.PlantsPageModule)
  },
  {
    path: 'management',
    loadChildren: () => import('./management/management.module').then( m => m.ManagementPageModule)
  },
  {
    path: 'plantinfo',
    loadChildren: () => import('./plantinfo/plantinfo.module').then( m => m.PlantinfoPageModule)
  },
  {
    path: 'plant-details/:id',
    loadChildren: () => import('./plant-details/plant-details.module').then( m => m.PlantDetailsPageModule)
  },
  {
    path: 'graph-list/:id',
    loadChildren: () => import('./graph-list/graph-list.module').then( m => m.GraphListPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
